import { request } from './apiClient';
import { getSessionClientId } from './authSession';

// AJUSTE BACKEND AQUI: helper local para limpar tudo que nao for numero antes de enviar.
const onlyDigits = (value) => (value || '').replace(/\D/g, '');

// Monta o payload de cliente (camelCase, documentos só com dígitos) a partir do formulário.
// AJUSTE BACKEND AQUI: mapeamento do formulario para o contrato da API de cliente.
export const buildClientePayload = (formData) => ({
  razaoSocial: formData.razaoSocial.trim(),
  numrCnpj: onlyDigits(formData.numrCnpj),
  numrCpf: onlyDigits(formData.numrCpf),
  endereco: formData.endereco.trim(),
  codgCep: onlyDigits(formData.codgCep) ? Number(onlyDigits(formData.codgCep)) : null,
  idCidade: formData.idCidade ? Number(formData.idCidade) : null,
  idUsuarioTecnico: formData.idUsuarioTecnico ? Number(formData.idUsuarioTecnico) : null,
  idUsuarioFinanceiro: formData.idUsuarioFinanceiro ? Number(formData.idUsuarioFinanceiro) : null,
  idUsuarioAdministrativo: formData.idUsuarioAdministrativo ? Number(formData.idUsuarioAdministrativo) : null,
});

// Lista todos os clientes.
export const getCliente = async (idCliente) => {
  // AJUSTE BACKEND AQUI: endpoint de listagem de clientes.
  const effectiveClientId = getSessionClientId();
  return await request(`/api/cliente?idCliente=${effectiveClientId}`);
};

// Cria um cliente; retorna { response, payload }.
export const createCliente = async (formData) => {
  const payload = buildClientePayload(formData);

  // AJUSTE BACKEND AQUI: endpoint de criacao de cliente.
  const response = await request('/api/cliente', {
    method: 'POST',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Atualiza o cliente por id; retorna { response, payload }.
export const updateCliente = async (id, formData) => {
  const payload = buildClientePayload(formData);

  // AJUSTE BACKEND AQUI: update por id do cliente.
  const response = await request(`/api/cliente/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  });

  return { response, payload };
};

// Exclui o cliente por id.
export const deleteCliente = async (id) => {
  // AJUSTE BACKEND AQUI: exclusao por id do cliente.
  return await request(`/api/cliente/${id}`, {
    method: 'DELETE'
  });
};

// --- Logo do cliente (usado no cabeçalho dos relatórios em PDF) ---------------------------------
// O cliente é sempre o da sessão; o backend guarda um único logo (upsert).

// Envia/substitui o logo do cliente. `file` é um File. Retorna { dataUri, nome, criadoEm }.
export const uploadLogoCliente = async (file) => {
  const formPayload = new FormData();
  formPayload.append('arquivo', file);
  // AJUSTE BACKEND AQUI: PUT /api/cliente/logo (multipart, campo "arquivo").
  return await request('/api/cliente/logo', { method: 'PUT', body: formPayload });
};

// Busca o logo atual do cliente como data URI base64. Retorna null quando não há logo (204).
export const getLogoCliente = async () => {
  // AJUSTE BACKEND AQUI: GET /api/cliente/logo -> { dataUri, nome, criadoEm } | 204.
  return await request('/api/cliente/logo');
};

// Remove o logo do cliente.
export const deleteLogoCliente = async () => {
  // AJUSTE BACKEND AQUI: DELETE /api/cliente/logo.
  return await request('/api/cliente/logo', { method: 'DELETE' });
};